<template>
  <Transition name="vendor-details-search-overlay">
    <div
      v-if="isOpen"
      class="vendor-details-search-modal-overlay vendor-details-search-modal-overlay--glass"
      @click.self="closeModal"
    >
      <Transition name="vendor-details-search-panel" appear>
        <div
          class="vendor-details-search-modal vendor-details-search-modal--glass"
          role="dialog"
          aria-labelledby="vendor-details-search-modal-title"
          @click.stop
        >
          <div class="vendor-details-search-modal-header vendor-details-search-modal-header--glass">
            <h2 id="vendor-details-search-modal-title" class="vendor-details-search-modal-title">
              <i class="bi bi-search vendor-details-search-modal-title__icon" aria-hidden="true"></i>
              Search
            </h2>
            <div class="vendor-details-search-modal-header-actions">
              <button
                type="button"
                class="vendor-details-search-icon-btn"
                aria-label="Help"
                title="Help"
                @click="$emit('help')"
              >
                <i class="bi bi-question-circle" aria-hidden="true"></i>
              </button>
              <button
                type="button"
                class="vendor-details-search-icon-btn vendor-details-search-icon-btn--close"
                aria-label="Close"
                title="Close"
                @click="closeModal"
              >
                <i class="bi bi-x-lg" aria-hidden="true"></i>
              </button>
            </div>
          </div>

          <div class="vendor-details-search-modal-body vendor-details-search-modal-body--glass">
            <div class="vendor-details-search-form">
              <div class="vendor-details-search-form-group vendor-details-search-form-group--1">
                <LabelDropdown
                  label="Transaction Type"
                  select-id="vendor-details-search-transaction-type"
                  v-model="transactionType"
                  flex
                  wide
                  :options="transactionTypeOptions"
                />
              </div>
              <div class="vendor-details-search-form-group vendor-details-search-form-group--2">
                <LabelDropdown
                  label="Search"
                  select-id="vendor-details-search-search-type"
                  v-model="searchType"
                  flex
                  wide
                  :options="searchTypeOptions"
                />
              </div>
              <div class="vendor-details-search-form-group vendor-details-search-form-group--3">
                <LabelInputField
                  input-id="vendor-details-search-find-by"
                  label="Find By"
                  v-model="findBy"
                  type="number"
                  flex
                />
              </div>
              <div class="vendor-details-search-form-group vendor-details-search-form-group--4">
                <LabelDropdown
                  label="Match"
                  select-id="vendor-details-search-match-type"
                  v-model="matchType"
                  flex
                  wide
                  :options="matchTypeOptions"
                />
              </div>
            </div>

            <p class="vendor-details-search-status">
              <span class="vendor-details-search-status__label">Status:</span>
              {{ statusMessage }}
            </p>
          </div>

          <div class="vendor-details-search-modal-footer vendor-details-search-modal-footer--glass">
            <SecondaryButton label="Close" icon="" @click="closeModal" />
            <PrimaryButton label="Find" icon="bi bi-search" @click="onFind" />
          </div>
        </div>
      </Transition>
    </div>
  </Transition>
</template>

<script>
import '../styles/VendorDetailsSearch.css';
import LabelDropdown from '@/modules/consultant/components/LabelDropdown.vue';
import LabelInputField from '@/modules/consultant/components/LabelInputField.vue';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';

export default {
  name: 'VendorDetailsSearch',
  components: {
    LabelDropdown,
    LabelInputField,
    PrimaryButton,
    SecondaryButton,
  },
  data() {
    return {
      isOpen: true,
      transactionType: 'All',
      searchType: 'All',
      findBy: 0,
      matchType: 'Exact',
      statusMessage: 'Select criteria above and press Find',
    };
  },
  computed: {
    transactionTypeOptions() {
      return [
        { value: 'All', label: 'All' },
        { value: 'Bill Payment', label: 'Bill Payment' },
        { value: 'Amount', label: 'Amount' },
      ];
    },
    searchTypeOptions() {
      return [
        { value: 'All', label: 'All' },
        { value: 'Amount', label: 'Amount' },
      ];
    },
    matchTypeOptions() {
      return [
        { value: 'Exact', label: 'Exact' },
        { value: 'Partial', label: 'Partial' },
      ];
    },
  },
  methods: {
    closeModal() {
      if (!this.isOpen) return;
      this.isOpen = false;
      window.setTimeout(() => {
        this.$emit('close');
      }, 300);
    },
    onFind() {
      this.statusMessage = 'Searching with selected criteria…';
      this.$emit('find', {
        transactionType: this.transactionType,
        searchType: this.searchType,
        findBy: Number(this.findBy) || 0,
        matchType: this.matchType,
      });
    },
  },
};
</script>
